import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { KpiService } from "../../kpi/kpi.service";
import * as Constants from "../../constants";

@Component({
  selector: "grouping-body-title",
  templateUrl: "./grouping-body-title.component.html",
  styleUrls: ["./grouping-body-title.component.scss"],
})
export class GroupingBodyTitleComponent implements OnInit {
  @Input() name;
  @Input() selectedDataConfig;

  @Output() toggledEvent = new EventEmitter();

  helpUrl: string;

  tooltipText =
    "Visible subgroups will show up as one of the filter options on your metric tiles. Changes will take effect within 24 hours.";
  email;
  isStarterUser: boolean;

  constructor(private kpiService: KpiService) {}

  ngOnInit() {
    this.kpiService.getUserInfo().subscribe(
      (data) => {
        this.email = data.email;
        this.isStarterUser = data.sz_tier === Constants.TIERS.STARTER.key;
        this.helpUrl = this.isStarterUser
          ? Constants.HELP_URLS.DATA_CONFIGURATION_STARTER_URL
          : Constants.HELP_URLS.DATA_CONFIGURATION_NONSTARTER_URL;
      },
      (error) => {
        console.error(error);
      }
    );
  }

  visibilityToggled(event) {
    this.toggledEvent.emit(event);
  }

  reportIssue() {
    let name = this.selectedDataConfig.aggregategroup_displayname
      ? encodeURIComponent(this.selectedDataConfig.aggregategroup_displayname)
      : "";
    window.open(
      `https://support.schoolzilla.org/hc/en-us/requests/new?ticket_form_id=18129&description=If+${name}+values+are+incorrect,+please+tell+us+which+table+and+column+name(s)+in+your+student+information+system+to+use,+if+known&subject=Issue+with+${name}+Configuration&anonymous_requester_email=${encodeURIComponent(
        this.email
      )}&file_or_data_source_name=test_file.txt`,
      "_blank"
    );
  }
}
